/*eslint-disable*/
import React, { useState } from "react";
import SampleDp from "../../../../../assets/Images/sample-dp.png";
import { ReactComponent as ArrowUpIm } from "../../../../../assets/Icons/Universal/BsBoxArrowUpRight.svg";
import FormInput from "../../../../Universal/FormInput.component";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import { Formik } from "formik";
import MemberFormValidation from "../../../Organizational/Management/Members/MemberFormValidation.component";
import "../../../../../styles/Pages/Financial/CashInFlow/Fees/NormalFeeBox.style.css";

const NormalFeesBox = () => {
  const [submittedValues, setSubmittedValues] = useState(null);
  const feeCategories = [
    "Admission fees",
    "Monthly fees/ Semester",
    "Medical charges",
    "Library due",
    "Restitution charges",
    "Development fees",
    "Software charges",
    "Transportation",
    "Other service charges",
  ];
  const paymentMethods = [
    "Online Banking/ Net Banking",
    "UPI",
    "Cash",
    "Check",
    "Debit/Credit card",
  ];

  return (
    <div className="NormalFeeBoxContainer">
      <div className="titleContainer">
        <div className="frontSection">
          <div className="profile-dp">
            <img src={SampleDp} alt="dp" />
            <div className="infoContainer">
              <div className="name">Taufik Alam</div>
              <div className="gender">Male</div>
            </div>
          </div>
          <span className="seeHistory">
            See History <ArrowUpIm />
          </span>
        </div>
        <div className="id">SM0523019</div>
        <div className="class">Class 5/A</div>
        <div className="date">
          <div className="lastFee">Last fees collect: 23 Oct, 2025</div>
          <div className="period">Last month: August</div>
        </div>
      </div>
      <div className="formContainer">
        <Formik
          initialValues={{
            payment: "",
            fees: "",
            paymentMode: "",
            authorizedBy: "",
          }}
          validationSchema={MemberFormValidation} // Validation schema
          onSubmit={(values) => {
            console.log("Form Submitted:", values); // Log the values
            setSubmittedValues(values); // Store the submitted values in state
          }}
        >
          {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => {
            console.log(errors);

            return (
              <form onSubmit={handleSubmit} className="liabilitiesForm">
                <div className="CollectFeesFormInputs">
                  <div className="memberAddFormTextInputs">
                    <DropDownInput
                      name="payment"
                      label="Payment For"
                      setFieldValue={(val) => setFieldValue("payment", val)}
                      placeholder={"Choose money collection"}
                      suggestionList={feeCategories}
                      errors={errors}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                      touched={touched}
                    />

                    <br />
                    <hr />
                    <br />
                    <FormInput
                      label="Fees(INR)"
                      type="number"
                      name="fees"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter fees amount"
                      setFieldValue={(e) =>
                        setFieldValue("fees", e.target.value)
                      }
                    />
                    <DropDownInput
                      name="paymentMode"
                      label="Payment Mode"
                      setFieldValue={(val) =>
                        setFieldValue("paymentMode", val)
                      }
                      placeholder={"Choose payment mode"}
                      suggestionList={paymentMethods}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <DropDownInput
                      name="authorizedBy"
                      label="Authorized By"
                      setFieldValue={(val) =>
                        setFieldValue("authorizedBy", val)
                      }
                      placeholder={"Choose e-signatory"}
                      suggestionList={[""]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <button type="submit" className="liabilityFormSubmitBtn">
                      Collect
                    </button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default NormalFeesBox;